import ActionType from 'actions/ActionType'

export const toggleModal = (payload) => (dispatch) =>
  dispatch({
    type: ActionType.Phone.TOGGLE_MODAL,
    payload,
  })

export const setPhoneState = (payload) => (dispatch) =>
  dispatch({
    type: ActionType.Phone.SET_STATE,
    payload,
  })
